import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import FirstPage from './components/FirstPage.js';
import ArtPieces from './components/ArtPieces.js';
import TechnologyProject from './components/TechnologyProjects.js';
import Recipes from './components/Recipes.js';
import Traveling from './components/Traveling.js';
import PhotoDetails from './components/PhotoDetails.js';
import ContactPage from './components/ContactPage.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FirstPage />} />
        <Route path="/firstpage" element={<FirstPage />} />
        <Route path="/artpieces" element={<ArtPieces />} />
        <Route path="/technologyprojects" element={<TechnologyProject />} />
        <Route path="/recipes" element={<Recipes />} />
        <Route path="/traveling" element={<Traveling />} />
        <Route path="/contactpage" element={<ContactPage />} />
        <Route path="/photos/:category/:id" element={<PhotoDetails />} />
      </Routes>
    </Router>
  );
}

export default App;